import { useQueryClient } from '@tanstack/react-query';

import { type CurbsideInfo } from '../api';
import { CURBSIDE_INFO_KEY } from './queryKey';

export type UseCurbsideQueryResult = {
    curbsideData: CurbsideInfo | undefined;
};

export const useCurbsideQuery = (): UseCurbsideQueryResult => {
    const queryClient = useQueryClient();

    const curbsideData = queryClient.getQueryData<CurbsideInfo>([CURBSIDE_INFO_KEY]);

    return { curbsideData };
};
